<template>
  <collective-detail breadcrumb-route="courses" item-type="courses" item-type-single="course" />
</template>

<script>
import CollectiveDetail from '@/views/apps/collectives/components/CollectiveDetail.vue';

export default {
  name: 'Course',
  components: {
    CollectiveDetail,
  },
};
</script>

<style>

</style>
